import React, { useEffect, useState, Component } from "react";
import { FormGroup, Panel } from "react-bootstrap";
import {
  Form,
  Dropdown,
  GridColumn,
  Grid,
  GridRow,
  TextArea,
  FormInput,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import { format, compareAsc } from "date-fns";
import { useFormik } from "formik";
import Holidays from "date-holidays";
import { add } from "lodash";
var moment = require("moment-business-days");

export const AppointmentComponent = (props) => {
  const timeSlots = [
    { key: "0", value: "0", text: "Any", flag: "Any" },
    { key: "1", value: "1", text: "AM", flag: "AM" },
    { key: "2", value: "2", text: "PM", flag: "PM" },
  ];

  const appointmentTypes =
    props.allowedAppointmentTypes?.map((type) => ({
      key: type.toLowerCase(),
      value: type,
      text: type,
      flag: type,
    })) || [];

  const [country, setCountry] = useState("GB");
  const hd = new Holidays(country);
  const holidays = hd.getHolidays();
  const leadTime = addLeadTime(new Date());
  const [minDate, setMinDate] = useState();

  // Extract unique dates from appointmentList.availableAppointments

  const [appointmentType, setAppointmentType] = useState({
    appointmentTypeField: "",
  });

  const getAvailableDates = () => {
    // Check if appointmentList exists and has availableAppointments array with items
    if (
      !props.appointmentList ||
      !props.appointmentList.availableAppointments ||
      !Array.isArray(props.appointmentList.availableAppointments) ||
      props.appointmentList.availableAppointments.length === 0
    ) {
      return null;
    }
    
    try {
      const uniqueDates = [
        ...new Set(
          props.appointmentList.availableAppointments
            .filter(
              (appt) =>
                !appointmentType.appointmentTypeField ||
                appt.appointmentType === appointmentType.appointmentTypeField
            )
            .map((appt) => new Date(appt.date).toDateString())
        ),
      ];

      return uniqueDates.map((dateString) => new Date(dateString));
    } catch (error) {
      console.error("Error processing appointmentList:", error);
      return null;
    }
  };

  const availableDates = getAvailableDates();

  // Calculate minDate: first available date or leadTime
  const getMinDate = () => {
    if (availableDates && availableDates.length > 0) {
      // Find the earliest date from availableDates
      const earliestDate = availableDates.reduce((earliest, current) => {
        return current < earliest ? current : earliest;
      });
      return earliestDate;
    }
    return new Date(leadTime);
  };

  useEffect(() => { 
    setMinDate(getMinDate());
  }, []);

  // Set startDate to minDate so it shows the first available date by default
  const [startDate, setStartDate] = useState();
  const [timeslot, setTimeSlot] = useState({ preferredTimeslotField: "" });

  const handleAppointmentTypeChange = (event, result) => {
    const { name, value } = result || event.target;
    setAppointmentType({ ...appointmentType, [name]: value });
    if (props.onAppointmentTypeChange) {
      props.onAppointmentTypeChange(value);
    }
  };

  function addLeadTime() {
    moment.locale("en-gb");
    let originalLeadTime = moment(props.today, "dd.MM.yyyy").businessAdd(
      props.leadTimeDays
    );

    holidays.forEach((element) => {
      if (
        (moment(element.date).isSame(originalLeadTime._d, "day") &&
          element.type === "public") ||
        (moment(element.date).isSame(originalLeadTime._d, "day") &&
          element.type === "bank")
      ) {
        originalLeadTime = moment(originalLeadTime, "dd.MM.yyyy").businessAdd(
          1
        );
      }
    });

    return originalLeadTime;
  }

  const isWeekdayOrHoliday = (date) => {
    // If we have available dates from appointmentList.availableAppointments, use those for filtering
    if (availableDates) {
      return availableDates.some(
        (availableDate) => availableDate.toDateString() === date.toDateString()
      );
    }

    // Otherwise use the original logic
    const day = date.getDay();
    var show = day !== 0 && day !== 6;

    holidays.forEach((element) => {
      if (moment(date).isSame(element.date, "day")) {
        show = false;
      }
    });
    return show;
  };

  const {
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    isValid,
    errors,
    ...formik
  } = useFormik({
    validate,
    validateOnChange: true,
    validateOnMount: true,
    initialValues: {
      preferredDateField: "",
      preferredTimeslotField: "",
    },
  });

  function validate({ preferredDateField, preferredTimeslotField }) {
    const errors = {};

    if (preferredDateField < todaysDate) {
      errors.preferredDateField = true;
    }

    if (!preferredTimeslotField.length) {
      errors.preferredTimeslotField = true;
    }

    return errors;
  }

  useEffect(() => {}, [props.isVisible]);

  const handleStartDateChange = (e, date) => {
    setStartDate(e);
    setFieldValue("activationDateField", e);
  };

  const todaysDate = new Date();

  const handleTimeslotChange = (event, result) => {
    const { name, value } = result || event.target;
    setTimeSlot({ ...timeslot, [name]: value });
  };

  if (props.isVisible === true) {
    return (
      <Grid columns={2} style={{ marginLeft: "2px" }} columns="equal">
        <GridRow>
          <GridColumn>
            <FormGroup>
              <Form.Field label="Appointment Details" />
            </FormGroup>
          </GridColumn>
        </GridRow>

        {appointmentTypes?.length > 0 && (
          <GridRow>
            <GridColumn>
              <FormGroup>
                <FormInput
                  inline
                  label="Appointment Type"
                  name="appointmentTypeLabel"
                  data-testid="appointmentTypeLabel"
                >
                  <Dropdown
                    placeholder="Select Appointment Type"
                    search
                    selection
                    options={appointmentTypes}
                    label="Appointment Type"
                    name="appointmentTypeField"
                    value={appointmentType.appointmentTypeField}
                    id="appointmentTypeField"
                    onChange={handleAppointmentTypeChange}
                    required
                    width="100%"
                  />
                </FormInput>
              </FormGroup>
            </GridColumn>
          </GridRow>
        )}

        <GridRow>
          <GridColumn>
            <FormGroup>
              <FormInput
                inline
                label="Preferred Date"
                name="activationDateField"
                data-testid="activationDateField"
              >
                <DatePicker
                  selected={startDate}
                  onChange={(e, val) =>
                    handleStartDateChange(e, val, setFieldValue)
                  }
                  locale="enGB"
                  dateFormat="dd/MM/yyyy"
                  name="activationDateField"
                  value={values.preferredDate}
                  id="activationDateField"
                  minDate={minDate}
                  filterDate={isWeekdayOrHoliday}
                  highlightDates={availableDates || []}
                  includeDates={availableDates || undefined}
                  autoComplete="off"
                />
              </FormInput>
            </FormGroup>
          </GridColumn>
          <GridColumn>
            <FormGroup>
              <FormInput
                inline
                label="Preferred Timeslot"
                name="preferredTimeSlotLabel"
                data-testid="preferredTimeSlotLabel"
              >
                <Dropdown
                  placeholder="Select Preferred Timeslot"
                  search
                  selection
                  options={timeSlots}
                  label="Preferred Timeslot"
                  name="preferredTimeslotField"
                  value={timeslot.timeSlotField}
                  id="preferredTimeslotField"
                  onChange={handleTimeslotChange}
                />
              </FormInput>
            </FormGroup>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <FormGroup>
              <TextArea
                placeholder="Site safety notes"
                style={{ minHeight: 100 }}
                fluid
                className="ui textarea margin"
                id="siteSafetyNotesField"
              />
            </FormGroup>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <FormGroup>
              <TextArea
                placeholder="Site visit notes"
                style={{ minHeight: 100 }}
                fluid
                className="ui textarea margin"
                id="sitevisitNotesField"
              />
            </FormGroup>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <FormGroup>
              <TextArea
                placeholder="Site special arrangement notes"
                style={{ minHeight: 100 }}
                fluid
                className="ui textarea margin"
                id="specialArrangementNotesField"
              />
            </FormGroup>
          </GridColumn>
        </GridRow>
      </Grid>
    );
  } else return null;
};
